function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 433 499"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M195.677 12.446 21.507 112.96A43 43 0 0 0 0 150.203V349.68a43 43 0 0 0 21.634 37.316l174.17 99.728a43 43 0 0 0 42.844-.064l172.829-99.642A43 43 0 0 0 433 349.766V150.118c0-15.32-8.15-29.482-21.396-37.179L238.774 12.511a43 43 0 0 0-43.097-.065",
    className: "logo_svg__logo-hexagon",
    style: {
      fill: "var(--logo-hexagon-color, #269CE8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M333 151v167.5L286.5 272V151a9 9 0 0 1 9-9H324a9 9 0 0 1 9 9M100 348.5V181l46.5 46.5v121a9 9 0 0 1-9 9H109a9 9 0 0 1-9-9m0-182v-15a9 9 0 0 1 9-9h25.873a16 16 0 0 1 11.313 4.686L333 334v14a9 9 0 0 1-9 9h-26.873a16 16 0 0 1-11.313-4.686z",
    className: "logo_svg__logo-n",
    clipRule: "evenodd",
    style: {
      fill: "var(--logo-n-color, #FFFFFF)"
    }
  }));
};
export default SvgLogo;